const userRoleDetailsColumns = [
	{ field: 'roleName', header: 'Role Name' },
	{ field: 'roleDescription', header: 'Role Description' },
	// { field: 'permissions', header: 'Permissions' },
	{ field: 'createdBy', header: 'Created By' },
	{ field: 'updatedBy', header: 'Updated By' },
	{ field: 'approvedBy', header: 'Approved By' },
];

export default userRoleDetailsColumns;
